import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ControllerFlowStepsProvider from './hooks/ControllerFlowStepsContext';
import Error from './pages/Error';
import ReactiveAccount from './pages/ReactiveAccount';
import SignInWizard from './pages/SignInWizard';
import SignUpNativo from './pages/SignUpNativo';
import ForgetPasswordWizard from './pages/ForgetPasswordWizard';
import ValidateEmailLink from './pages/ValidateEmailLink';
import AccountRecoveryWizard from './pages/AccountRecovery/AccountRecoveryWizard';
import ProtectedRoute from './auth/ProtectedRoute';
import SocialMediaProvider from './hooks/ControllerSocialMedia';
import CreatePassword from './pages/MenuAccount/CreatePassword';
import AccountRecoveryProvider from './data/AccountRecovery/AccountRecoveryContext';
import { useAuthContext } from './hooks/AuthContext';
import { useEffect } from 'react';
import TermsAndPolicy, { TERMS_POLICY_TYPES } from './pages/TermsPolicy';
import CTVCheckCode from './pages/CTV/CTVCheckCode';
import CTVSuccess from './pages/CTV/CTVSuccess';
import GoogleRedirect from './pages/OAuthRedirect/GoogleRedirect';
import FacebookRedirect from './pages/OAuthRedirect/FacebookRedirect';
import AppleRedirect from './pages/OAuthRedirect/AppleRedirect';
import MicrosoftRedirect from './pages/OAuthRedirect/MicrosoftRedirect';
import SocialConnectionError from './pages/SocialConnectionError';
import UserProfile from './pages/UserProfile';
import SobreTab from './pages/UserProfile/tabs/SobreTab';
import SegurancaTab from './pages/UserProfile/tabs/SegurancaTab';
import AtividadesTab from './pages/UserProfile/tabs/AtividadesTab';
import PreferenciasTab from './pages/UserProfile/tabs/PreferenciasTab';
import SimpleTab from './pages/UserProfile/tabs/SimpleTab';

export function AppRoutes() {
  const { user } = useAuthContext();

  useEffect(() => {
    const elem = document.querySelector('body') as HTMLElement;
    if (user) {
      elem.classList.add('openedSess');
    } else {
      elem.classList.remove('openedSess');
    }
  }, [user]);

  return (
    <BrowserRouter>
      <ControllerFlowStepsProvider>
        <SocialMediaProvider>
          <Routes>
            <Route path="" element={<SignInWizard />} />

            <Route
              path="termos-de-uso"
              element={<TermsAndPolicy type={TERMS_POLICY_TYPES.TERMS} />}
            />
            <Route
              path="politica-de-privacidade"
              element={<TermsAndPolicy type={TERMS_POLICY_TYPES.POLICY} />}
            />

            <Route path="callback/oauth/google" element={<GoogleRedirect />} />
            <Route
              path="callback/oauth/facebook"
              element={<FacebookRedirect />}
            />
            <Route path="callback/oauth/apple" element={<AppleRedirect />} />
            <Route
              path="callback/oauth/microsoft"
              element={<MicrosoftRedirect />}
            />

            <Route path="entrar" element={<CTVCheckCode />} />
            <Route path="cadastrar" element={<CTVCheckCode />} />
            <Route path="ctv/sucesso" element={<CTVSuccess />} />

            <Route path="signup" element={<SignUpNativo />} />
            <Route path="signup/:step" element={<SignUpNativo />} />
            <Route path="signup/:step/:step" element={<SignUpNativo />} />

            <Route path="videos/signup" element={<SignUpNativo />} />
            <Route path="videos/signup/:step" element={<SignUpNativo />} />

            <Route path="sbt/signup" element={<SignUpNativo />} />
            <Route path="sbt/signup/:step" element={<SignUpNativo />} />

            <Route path="signin" element={<SignInWizard />} />
            <Route path="signin/:step" element={<SignInWizard />} />

            <Route path="videos" element={<SignInWizard />} />
            <Route path="videos/signin" element={<SignInWizard />} />
            <Route path="videos/signin/:step" element={<SignInWizard />} />

            <Route path="sbt" element={<SignInWizard />} />
            <Route path="sbt/signin" element={<SignInWizard />} />
            <Route path="sbt/signin/:step" element={<SignInWizard />} />

            <Route path="recuperar-senha" element={<ForgetPasswordWizard />} />
            <Route
              path="recuperar-senha/:step"
              element={<ForgetPasswordWizard />}
            />
            <Route
              path="videos/recuperar-senha"
              element={<ForgetPasswordWizard />}
            />
            <Route
              path="videos/recuperar-senha/:step"
              element={<ForgetPasswordWizard />}
            />
            <Route
              path="sbt/recuperar-senha"
              element={<ForgetPasswordWizard />}
            />
            <Route
              path="sbt/recuperar-senha/:step"
              element={<ForgetPasswordWizard />}
            />

            <Route path="recuperar-conta" element={<AccountRecoveryWizard />} />
            <Route
              path="recuperar-conta/:step"
              element={<AccountRecoveryWizard />}
            />
            <Route
              path="videos/recuperar-conta"
              element={<AccountRecoveryWizard />}
            />
            <Route
              path="videos/recuperar-conta/:step"
              element={<AccountRecoveryWizard />}
            />
            <Route
              path="sbt/recuperar-conta"
              element={<AccountRecoveryWizard />}
            />
            <Route
              path="sbt/recuperar-conta/:step"
              element={<AccountRecoveryWizard />}
            />
            <Route path="reativar-conta" element={<ReactiveAccount />} />
            <Route path="videos/reativar-conta" element={<ReactiveAccount />} />
            <Route path="sbt/reativar-conta" element={<ReactiveAccount />} />
            <Route path="validar-email" element={<ValidateEmailLink />} />

            <Route
              path="social-connection-error"
              element={<SocialConnectionError />}
            />

            <Route element={<ProtectedRoute />}>
              <Route path="perfil" element={<UserProfile />}>
                <Route index element={<Navigate to="sobre" replace />} />
                <Route path="sobre" element={<SobreTab />} />
                <Route
                  path="conquistas"
                  element={<SimpleTab label="Conquistas" />}
                />
                <Route
                  path="carteira"
                  element={<SimpleTab label="Carteira" />}
                />
                <Route
                  path="interesses"
                  element={<SimpleTab label="Interesses" />}
                />
                <Route path="atividades" element={<AtividadesTab />} />
                <Route path="seguranca" element={<SegurancaTab />} />
                <Route path="preferencias" element={<PreferenciasTab />} />
              </Route>

              <Route
                path="menu-de-conta"
                element={<Navigate to="/perfil/sobre" replace={true} />}
              />
              <Route
                path="menu-de-conta/excluir-conta"
                element={
                  <Navigate
                    to="/perfil/seguranca?secao=excluir-conta"
                    replace={true}
                  />
                }
              />
              <Route
                path="menu-de-conta/desativar-conta"
                element={
                  <Navigate
                    to="/perfil/seguranca?secao=excluir-conta"
                    replace={true}
                  />
                }
              />
              <Route
                path="menu-de-conta/atualizar-dados/*"
                element={<Navigate to="/perfil/sobre" replace={true} />}
              />
              <Route
                path="menu-de-conta/gerenciar-sessoes-ativas"
                element={<Navigate to="/perfil/seguranca" replace={true} />}
              />
              <Route
                path="menu-de-conta/preferencias-de-comunicacao/*"
                element={<Navigate to="/perfil/preferencias" replace={true} />}
              />

              <Route
                path="menu-de-conta/criar-senha"
                element={
                  <AccountRecoveryProvider>
                    <CreatePassword />
                  </AccountRecoveryProvider>
                }
              />
              <Route
                path="menu-de-conta/*"
                element={<Navigate to="/perfil/sobre" replace={true} />}
              />
            </Route>

            <Route path="*" element={<Error />} />
          </Routes>
        </SocialMediaProvider>
      </ControllerFlowStepsProvider>
    </BrowserRouter>
  );
}
